import { render, staticRenderFns } from "./documentation-itemScan.vue?vue&type=template&id=33dac634&scoped=true"
import script from "./documentation-itemScan.vue?vue&type=script&lang=js"
export * from "./documentation-itemScan.vue?vue&type=script&lang=js"
import style0 from "./documentation-itemScan.vue?vue&type=style&index=0&id=33dac634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dac634",
  null
  
)

export default component.exports